<template>
  <ChannelLayoutLegacy v-if="!newLayout" />
  <ChannelLayoutV2 v-else>
    <template v-if="$slots.topbar" #topbar="topbarProps">
      <slot name="topbar" v-bind="topbarProps" />
    </template>
  </ChannelLayoutV2>
</template>

<script setup lang="ts">
import { useFeatureFlags } from "@/composables/use-feature-flags";
import ChannelLayoutLegacy from "./channel/channel-layout-legacy.vue";
import ChannelLayoutV2 from "./channel/channel-layout-v2.vue";

const { getBoolean } = useFeatureFlags();
const newLayout = getBoolean("enable_new_channel_layout");
</script>
